import "../src/styles/App.scss";
import "../src/styles/PromoText.scss";
import "../src/styles/Background.scss";
import "../src/styles/Form.scss";
import "../src/styles/Font.scss";
import "../src/styles/ProgressBar.scss";

import Background01 from "../src/images/background01.png";
import Background02 from "../src/images/background02.png";
import Logo from "../src/images/logo.png";
import AppForm from "./AppForm";

import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Axios } from "./Axios";
import { useEffect } from "react";
import CheckMailErrPage from "./check-email-err-page";
import SuccessPage from "./SucessPage";
import { useTranslation } from "react-i18next";
import i18n from "./locale";

function App() {
  const location = useLocation();
  const queryParameters = new URLSearchParams(window.location.search);
  const token = queryParameters.get("token");

  const navigate = useNavigate();
  useEffect(() => {
    const checkToken = async () => {
      if (token) {
        try {
          await Axios.get(`/verify?online_account=${token}`);
          navigate("/finish");
        } catch (e: any) {
          navigate("/token_not_found");
        }
      }
    };
    checkToken();
    // eslint-disable-next-line
  }, []);

  const { t } = useTranslation();
  const plusList = [
    t("signup__list__plus__easy_course_creation"),
    t("signup__list__plus__advanced_comunication"),
    t("signup__order_in_payments"),
    t("signup__advanced_reporting"),
    t("signup__management_instructors_locations"),
    t("signup__excellent_support"),
  ];
  const languges = [
    { name: "Slovenský", code: "sk" },
    { name: "English", code: "en" },
    { name: "Česky", code: "cs" },
    { name: "Deutsch", code: "de" },
  ];
  const handleChangeLanguage = (e: any) => {
    const lang = e.target.value;
    new URLSearchParams(window.location.search).set("lang", lang);
    localStorage.setItem("lang", lang);
    localStorage.setItem("i18nextLng", lang);
    if (lang) {
      i18n.changeLanguage(lang);
    }
  };
  useEffect(() => {
    const lang = new URLSearchParams(window.location.search).get("lang");
    if (lang) {
      localStorage.setItem("lang", lang);
      i18n.changeLanguage(lang);
      localStorage.setItem("i18nextLng", lang);
      const selectElement = document.getElementById(
        "languages"
      ) as HTMLSelectElement;
      if (selectElement) {
        selectElement.value = lang;
      }
    }
  }, []);

  return (
    <>
      {token === null && location.pathname !== "/token_not_found" && (
        <div className="content">
          <div className="appLogo">
            <img className="logo" src={Logo} alt="zooza logo" />
          </div>
          <div className="appLanguageDropdown">
            <select
              className="languages"
              id="languages"
              onChange={handleChangeLanguage}
              defaultValue={localStorage.getItem("lang") || "en"}
            >
              {languges.map((item: any, index: number) => (
                <>
                  <option key={index} value={item.code}>
                    {item.name}
                  </option>
                </>
              ))}
            </select>
          </div>
          <img className="background01" src={Background01} alt="waves orange" />
          <img className="background02" src={Background02} alt="waves blue" />
          <div className="appPromo">
            <h1>{t("signup__teaser")}</h1>

            <br></br>
            <h2>{t("signup__subteaser")}</h2>
          </div>
          <div className="appPromoList">
            <div className="appPromoList">
              <ul>
                {plusList.map((item: string, index: number) => (
                  <>
                    <li key={index}>
                      {item}
                      <span className="bullet"></span>
                    </li>
                  </>
                ))}
              </ul>
            </div>
          </div>{" "}
          <AppForm />
        </div>
      )}
      <Routes>
        <Route path="/finish" element={<SuccessPage />} />
        <Route path="/token_not_found" element={<CheckMailErrPage />} />
      </Routes>
    </>
  );
}

export default App;
